module.exports = __webpack_public_path__ + "img/bg-denne-vyhry-top.212d3e9.jpg";